// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1948":"aefcaf43","2273":"087c202d","6346":"b72a8383","7225":"2f7033b0","7281":"f31bee01","8942":"2f7033b0"}[chunkId] + ".chunk.css";
};